import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { CookieGuard } from '@core/auth/guards/cookie.guard';

const routes: Routes = [
  {
    path: 'meet/:token',
    pathMatch: 'full',
    loadComponent: () =>
      import('./content/main/modules/meet-scheduling/meet-scheduling-page.component').then(
        (m) => m.MeetSchedulingPageComponent
      )
  },
  {
    path: 'activate',
    loadChildren: () => import('./core/auth/activation/activation.module').then((m) => m.ActivationModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./core/auth/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'view-as',
    loadComponent: () => import('./core/auth/view-as/view-as.component').then((m) => m.ViewAsComponent)
  },
  {
    path: 'view-as-ended',
    loadComponent: () => import('./core/auth/view-as/view-as-ended.component').then((m) => m.ViewAsEndedComponent)
  },
  {
    path: 'logout',
    loadChildren: () => import('./core/auth/logout/logout.module').then((m) => m.LogoutModule)
  },
  {
    path: 'user-request',
    loadChildren: () => import('./core/auth/sign-up/sign-up.module').then((m) => m.SignUpModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./core/auth/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./core/auth/reset-password/reset-password.module').then((m) => m.ResetPasswordModule)
  },
  {
    path: 'anonymous',
    loadChildren: () => import('./content/main/modules/no-login/no-login.module').then((m) => m.NoLoginModule)
  },
  {
    path: 'community-header',
    loadChildren: () =>
      import('./content/main/modules/community-header/community-header.module').then((m) => m.CommunityHeaderModule)
  },
  {
    path: 'shipping/:id',
    loadChildren: () =>
      import('./content/main/modules/address-collection/address-collection.module').then(
        (m) => m.AddressCollectionModule
      )
  },
  {
    path: 'inapp',
    loadChildren: () => import('./content/main/modules/inapp/inapp.module').then((m) => m.InappModule),
    canActivate: [CookieGuard]
  },
  {
    path: 'unsubscribe',
    loadChildren: () => import('./content/main/modules/unsubscribe/unsubscribe.module').then((m) => m.UnsubscribeModule)
  },
  {
    path: 'video-testimonial-viewer/:campaignId/:challengeRecordUuid',
    loadChildren: () =>
      import(
        // eslint-disable-next-line max-len
        './content/main/modules/home/modules/challenge-page/components/video-testimonial-viewer/video-testimonial-viewer.module'
      ).then((m) => m.VideoTestimonialViewerModule)
  },
  {
    path: '',
    loadChildren: () => import('./content/main/main-layout.module').then((m) => m.MainLayoutModule),
    canLoad: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
